import "./Footer.css";

function Footer() {
    return (
        <footer className="footer" id="footer">
            <div className="footer-inner">
                <div className="footer-bottom">
                    <img
                        className="footer-emblem"
                        src="/img/Logos/unihubLogo1.png"
                        alt="UHub Latam"
                    />
                    <p>UHub Latam © 2025. All rights reserved.</p>
                    <p>Buenos Aires, Argentina</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
